// extracted by mini-css-extract-plugin
export default {"cls1":"fFUoXqcyZGcijm6RhkKO","cls2":"FiMGQrER83DHFwdczVvg fFUoXqcyZGcijm6RhkKO"};